
// const inViewport = require('in-viewport');

export const track = () => {
  loadScript('https://storage.googleapis.com/istrackers/istracker/production/istracker.js');
  initTracking();
};

// Tracking Middleware
export const trackingMiddleware = ({ getState }) => {
  return (next) => (action) => {
    next(action);
    window.istrack('swc.reducer', { action, getState });
  };
};

function loadScript(src, callback) {
  const script = document.createElement('script');
  let loaded;
  script.setAttribute('src', `${src}?t=${Date.now()}`);
  script.setAttribute('async', 'async');
  if (callback) {
    script.onload = function () {
      if (!loaded) {
        callback();
      }
      loaded = true;
    };
    script.onreadystatechange = script.onload;
  }
  document.getElementsByTagName('body')[0].appendChild(script);
}


/* eslint-disable */
function initTracking() {
  window._istagLayer = window._istagLayer || [];
  function istrack() { window._istagLayer.push(arguments); }
  window.istrack = istrack;
  istrack('plugin', { src: process.env.REACT_APP_TRACKING_URL, id: 'swc', callback: () => { istrack('swc.init', {}); } });
  // initializeViewPortHandler(istrack);
}
/* eslint-enable */

// function initializeViewPortHandler(istrack) {
//   const buyTicketElement = document.getElementById('buy-tickets');

//   inViewport(buyTicketElement, (el) => {
//     istrack('swc.view_port_buy-tickets', el);
//   });
// }



// WEBPACK FOOTER //
// ./src/common/tracker.js